import React, { Component, createRef } from "react";
import './index.css';
import BsyTextEditor from "../BsyTextEditor";
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsySLoading from "../BsySLoading";
import BsyCheckBoxGroup from "../BsyCheckBoxGroup";

export class UnbindApp extends Component {

  constructor(props) {
    super(props)
    this.state = {
      unBindKey: "",
      validateKey: "",
      app: props.app,
      apps: [],
      seleceGroup: [],
      isLoading: false,
      showAppList: false
    }
    this.inputKeyRef = createRef();
    this.inputValidateRef = createRef();
  }

  getUnBindApp = () => {
    const { app, unBindKey } = this.state;
    if (!this.state.unBindKey) {
      tipAlert({
        type: 'warning',
        msg: React.language("unbind.key.not.empty")
      })
      this.inputKeyRef.current.focus();
      return;
    }
    if (!/^[a-z0-9_]{24}$/.test(this.state.unBindKey)) {
      tipAlert({
        type: 'warning',
        msg: React.language("unbind.key.error")
      })
      this.inputKeyRef.current.focus();
      return;
    }

    this.setState({ isLoading: true });
    React.axios('/dashboard/standard_unbind_key_app', {
      appId: app._id,
      key: unBindKey
    }).then(res => {
      if (res.data.code === 200) {
        this.setState({ isLoading: false, apps: res.data.list, showAppList: true });
      } else {
        tipAlert({
          type: "warning",
          msg: res.data.msg
        })
        this.setState({ isLoading: false });
      }
    }).catch(res => {
      this.setState({ isLoading: false });
    })
  }

  unBindApp = () => {
    const { app, unBindKey } = this.state;
    if (this.state.validateKey !== React.language("unbind.validate.text")) {
      tipAlert({
        type: 'warning',
        msg: React.language('unbind.validate.hit')
      })
      this.inputValidateRef.current.focus();
      return;
    }
    this.setState({ isLoading: true });
    React.axios('/dashboard/standard_unbind', {
      appId: app._id,
      key: unBindKey
    }).then(res => {
      if (res.data.code === 200) {
        tipAlert({
          type: "success",
          msg: res.data.msg
        })
        this.props.onClose();
        window.location.reload();
      } else {
        tipAlert({
          type: "warning",
          msg: res.data.msg
        })
      }
    }).catch(res => {
      tipAlert({
        type: "warning",
        msg: `解绑失败，请稍后重试`
      })
      this.setState({ isLoading: false });
    })
  }

  render() {
    const { isLoading, apps } = this.state
    return (
      <div className={"bsy-unbind-app"}>
        <div className="input-validate"
          style={{
            display: !this.state.showAppList ? "" : "none"
          }}
        >
          <BsyTextEditor
            ref={this.inputKeyRef}
            value={this.state.unBindKey}
            hint={React.language('unbind.key.hint')}
            onAfterEdit={(val) => {
              this.setState({ unBindKey: val });
            }}
          ></BsyTextEditor>
          <BsyIconBtn
            text={React.language('unbind')}
            click={event => {
              this.getUnBindApp();
            }}
            mode={window.mode}
          />
        </div>
        <div className="unbind-app-list"
          style={{
            display: this.state.showAppList ? "flex" : "none"
          }}
        >
          <div className="app-title">
            <span>{React.language("app.list")}</span>
          </div>
          <div className="app-list">
            <BsyCheckBoxGroup
              value={this.state.seleceGroup}
              items={apps.map(it => ({
                text: it.appname,
                value: it._id,
                selected: this.state.seleceGroup.includes(it._id)
              }))}
              onStopEdit={(val) => {
                this.setState({ seleceGroup: val.sort() });
              }}
            />
          </div>
          <div className="input-validate">
            <BsyTextEditor
              ref={this.inputValidateRef}
              value={this.state.validateKey}
              hint={React.language('unbind.validate.hit')}
              onAfterEdit={(val) => {
                this.setState({ validateKey: val });
              }}
            ></BsyTextEditor>
            <BsyIconBtn
              text={React.language('unbind')}
              click={event => {
                this.unBindApp();
              }}
              mode={window.mode}
            />
          </div>
        </div>
        {
          isLoading && <BsySLoading />
        }
      </div>

    )
  }
}
